/*
 * Product-card "Add to cart" fix.
 *
 * On the custom mobile product card the product image is wrapped in a link
 * (.mobile_bls__img-url) with an image swiper, and the small Add-to-cart icon
 * is overlaid on top. A tap on that icon could fall through to the image link
 * and navigate to the product page instead of adding the item.
 *
 * This delegated handler guarantees that any click on a product-card
 * Add-to-cart control adds the first/selected variant to the cart and never
 * navigates. It runs in the capture phase and stops further propagation so the
 * theme's own per-button handler does not also fire (which would add twice),
 * while still reusing the theme's cart logic (mini-cart refresh, count, etc.).
 * It also works for cards added after page load (carousels, quick view, etc.).
 */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var btn = target.closest('.bls__js-addtocart');
      if (!btn) return;

      // Only handle Add-to-cart controls inside a product card, not the main
      // product form or other add buttons.
      if (!btn.closest('.bls__product-item')) return;

      // Prevent navigation to the product page and stop the theme's own
      // bubble-phase handler from firing a second add for the same click.
      e.preventDefault();
      e.stopImmediatePropagation();

      var api = window.BlsSectionProductAddCart;
      if (api && typeof api.actionAddToCart === 'function') {
        api.actionAddToCart(btn);
      }
    },
    true
  );
})();
